<template>
  <div>
    <h1>作业管理</h1>
  </div>
</template>

<script>
export default {
  name: 'HomeWork',
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/manager/components/HomeWork.vue